import React from 'react';
import { compose } from 'redux';
import DashboardTemplate from 'components/templates/Dashboard';
import HeaderContainer from 'containers/HeaderContainer';
import PageQuery from 'hoc/PageQuery';
import PageView from 'hoc/PageView';
import PageTitle from 'hoc/PageTitle';
import ProtectedRoute, { DashboardsProtections } from 'hoc/ProtectedRoute';
import PageTheme from 'hoc/PageTheme';

import DetermineLayerContainer from 'containers/dashboards/DetermineLayerContainer';
import LayerThreeVideoContainer from 'containers/dashboards/LayerThreeVideoContainer';
import LayerTwoVideoContainer from 'containers/dashboards/LayerTwoVideoContainer';

import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/DashboardSideBarObjects';
import showGGBrandingTheme from 'helpers/showGGBrandingTheme';
import { getQueryParamDefForObjectiveSwitcher } from 'helpers/objectiveSettings';
import { getQueryParamDefForRange } from 'helpers/range';

const VideoDashboard = props => (
    <DashboardTemplate
        header={<HeaderContainer />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer entityId={parseInt(props.match.params.entityId, 10)} />}>

        <DetermineLayerContainer
            layerTwo={LayerTwoVideoContainer}
            layerThree={LayerThreeVideoContainer}
            {...props} />
    </DashboardTemplate>
);

export default compose(
    ProtectedRoute(DashboardsProtections),
    PageTitle({ pageTitle: 'Video' }),
    PageView({ page: 'Viewed Entity Video', trackEntity: true }),
    PageTheme({ themeDefaults: { 'whitelabel.showGGBranding': showGGBrandingTheme } }),
    PageQuery({
        params: {
            ...getQueryParamDefForRange(),
            ...getQueryParamDefForObjectiveSwitcher()
        },
        initialTruth: 'location',
    }),
)(VideoDashboard);



// WEBPACK FOOTER //
// ./src/components/pages/dashboards/Video.js